import { render, staticRenderFns } from "./pageNumber.vue?vue&type=template&id=43279fba&scoped=true&"
import script from "./pageNumber.vue?vue&type=script&lang=js&"
export * from "./pageNumber.vue?vue&type=script&lang=js&"
import style0 from "./pageNumber.vue?vue&type=style&index=0&id=43279fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43279fba",
  null
  
)

export default component.exports